import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $isTextNode } from 'lexical';
import { useEffect } from 'react';

function patchStyleText(selection, styles) {
  if ($isRangeSelection(selection)) {
    const nodes = selection.getNodes();
    nodes.forEach((node) => {
      if ($isTextNode(node)) {
        node.setStyle({
          ...node.getStyle(),
          ...styles,
        });
      }
    });
  }
}

export default function ColorPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Color
    window.handleLexicalColorChange = (color) => {
      editor.update(() => {
        const selection = $getSelection();
        patchStyleText(selection, { color });
      });
    };
    // Highlight
    window.handleLexicalHighlightChange = () => {
      editor.update(() => {
        const selection = $getSelection();
        patchStyleText(selection, { 'background-color': 'yellow' });
      });
    };
    return () => {
      delete window.handleLexicalColorChange;
      delete window.handleLexicalHighlightChange;
    };
  }, [editor]);
  return null;
} 